import React from "react";
import SectionTitle from "@others/title-section.layout";
import {Box, Button, Card, CardActions, CardContent, Container, Grid, Typography} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faNewspaper} from "@fortawesome/free-solid-svg-icons";
import {news} from "../data";

const NewsPage: React.FC = () => {

    return(
        <>
            <Container sx={{ mb: 5}}>
                <Box sx={{ paddingTop: 2, paddingBottom: 2 }}>
                    <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />
                </Box>
                <Grid container spacing={4}>
                    {news.map((article) => (
                        <Grid size={{ xs: 12, md: 6, lg: 4 }} key={article.id}>
                            <Card
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    borderRadius: 3,
                                    boxShadow: 4,
                                    "&:hover": { boxShadow: 8 }
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        bgcolor: "#f4f7fa",
                                        py: 3,
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                    }}
                                >
                                    <FontAwesomeIcon icon={faNewspaper} size="2x" />
                                </Box>
                                <CardContent>
                                    <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                                        {article.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" gutterBottom>
                                        {article.date}
                                    </Typography>
                                    <Typography variant="body2" color="text.primary">
                                        {article.description}
                                    </Typography>
                                </CardContent>
                                <CardActions sx={{ mt: "auto", p: 2, pt: 0 }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        href={article.url}
                                        sx={{
                                            fontWeight: 600,
                                            textTransform: "none",
                                            borderRadius: 2
                                        }}
                                    >
                                        Lire l'article
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>

        </>
    )
}

export default NewsPage;